import React from "react";
import ReactDOM from "react-dom";
import Widget from "./Widget";
import ChatWidgetConfig from "./config/ChatWidgetConfig";

const mountWidget = (el, props) => {
  const config = {
    ...(window.ChatWidgetConfig || {}), // Allow dynamic global overrides
    ...props, // Props take the highest priority
  };
  ReactDOM.render(<Widget {...config} />, el);
};

// If you're using UMD, we need to ensure the global export is correct
if (typeof window !== "undefined") {
  window.ChatWidget = ChatWidget; // Ensure global access
}
const unmountWidget = (el) => {
  ReactDOM.unmountComponentAtNode(el); // Unmount the component from the DOM
};
// Ensure Webpack correctly exposes the library
const ChatWidget = { Widget, mountWidget ,unmountWidget};
window.ChatWidget = ChatWidget;

export default ChatWidget; // Important for Webpack
export { Widget, mountWidget , unmountWidget };
